const LocalStorageKeys = {
    IDENTITY: 'IDENTITY',
    LOGIN_DATA: 'loginData',
    ACCEPTED: 'accepted',
    REJECTED: 'rejected',
    SIDER_COLLAPSED: 'siderCollapsed',
    PROBLEM_SETS_SIDER_COLLAPSED: 'problemSetsSiderCollapsed',
    ACCESS_CODE: 'accessCode',
    ANON_FEEDBACK_ID: 'anonFeedbackId',
    DRAWER_WIDTH: 'drawerWidth',
    ANSWER_SPLITTER_RATIO: 'answerSplitterRatio',
    LAST_VISITED_ASSIGNMENT_VERSIONS: 'lastVisitedAssignmentVersions',
    LAST_VISITED_SUBMISSIONS: 'lastVisitedSubmissions',
    DRAFT_INSTANT_FEEDBACK_SOLUTIONS: 'draftInstantFeedbackSolutions',
    GROUP_BY_TYPE_FOR_QUESTION_PAGE: 'groupByTypeForQuestionPage',
    RECENT_ASSIGNMENTS: 'recentAssignments',
}
export default LocalStorageKeys
